exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-4daa1912] {\n  padding: 15px 34px;\n  display: flex;\n  justify-content: space-between;\n}\n.header h2[data-v-4daa1912] {\n  font-size: 18px;\n  font-weight: 600;\n}\n.header .status[data-v-4daa1912] {\n  font-size: 16px;\n}\n.n-acc-actions[data-v-4daa1912] {\n  background: #f6f8f9;\n  margin: 0 -30px;\n  padding: 10px 30px;\n}\n.comliance-header[data-v-4daa1912] {\n  border-bottom: 1px solid #99aabb;\n}", ""]);

// exports
